import { windowWidth } from "./utils";

const stickySidebar = {

    wrap: document.getElementById('jsProdWrap') as HTMLElement,
    topSect: document.getElementById('jsProdTop') as HTMLElement,
    dropdowns: document.querySelectorAll('.jsAccordianProd') as NodeListOf<HTMLElement>, 
    

    init() {
        if(windowWidth > 1199) {
            this.setSticky();
        }
    },


    setSticky() {
        this.dropdowns.forEach((item) => {
            let childItem = item.querySelector('.jsAccordianItem') as HTMLElement; 
            
            childItem.addEventListener('click', () => {
                if(childItem.dataset.open === 'false') {
                    this.wrap.style.top = '60px';
                } else {
                    this.wrap.style.top = `-${this.topSect.offsetHeight + 40}px`;
                }
            });




            
        });
    }



}

export default stickySidebar;